import { FullAuditable, HasId } from '../common';

export interface Payment extends HasId, FullAuditable {
    accessCode: string;
    transactionDate: Date;
    responseCode: string | null;
    message: string | null;
    success: boolean | null;
    amountInCents: number;
    receiptNumber: string | null;
    email: string | null;
    phoneNumber: string | null;
    businessName: string | null;
    invoiceDescription: string | null;
    invoiceNumber: string | null;
    invoiceReference: string | null;
    currency: string;
    status: string;
}

export const INVOICE_NUMBER_PREFIX = 'DS-';
export const INVOICE_REFERENCE_PREFIX = 'DS-';
export const SPECIAL_REQUEST_INVOICE_REFERENCE_PREFIX = `${INVOICE_REFERENCE_PREFIX}SR-`;
